import { createFileRoute } from "@tanstack/react-router";
import { protectedRoute } from "@/lib/protectedRoute";
import { Dashboard } from "@/pages/Dashboard";

export const Route = createFileRoute("/analytics")({
  component: Dashboard,
  beforeLoad: () => {
    return protectedRoute({ location: window.location });
  },
});
